module.exports = __webpack_public_path__ + "static/img/home_month1.d643133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_month1.png
// module id = UYj4
// module chunks = 4